import { action, computed, observable, set } from 'mobx';
import { autostore, HttpClient, Optional } from 'Mri.Web.Common';
import { DisplayViewTypes } from './DisplayViewSelector';
import {IWhereClause} from "./WhereFilter";

export class DisplayFiltersStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;

        autostore(this.storage, 'DisplayFiltersStore.DisplayFilterStorage', {
            useLocalStorage: true,
            useSessionStorage: true,
            useCustomStorage: false,
        });
    }

    public async loadAllFilterOptionsAsync() {
        await this.loadFilterOptionsAsync(undefined);
    }

    @action
    public async loadFilterOptionsAsync(displayFilter?: Mri.Web.Portal.Controllers.DisplayFilters.DisplayFilterModel) {
        const filterOptions = await this.httpClient.post<Mri.DisplayFilters.DisplayFilterOptions>(
            '/api/v1/display-filters/search',
            displayFilter,
            {
                cache: true,
            }
        );

        if (filterOptions) this.filterOptions.set(JSON.stringify(displayFilter ?? {}), filterOptions);
    }

    @computed
    public get all() {
        return this.filterOptions.get(JSON.stringify({}));
    }

    @observable
    public filterOptions = new Map<string, Mri.DisplayFilters.DisplayFilterOptions | undefined>();
    @observable
    public storage = new DisplayFilterStorage();

    private readonly httpClient: HttpClient;
}

class DisplayFilterStorage {
    public static version = 8;

    public isValid() {
        return this.version == DisplayFilterStorage.version;
    }

    @observable
    public version = DisplayFilterStorage.version;
    @observable
    public displayFilter = defaultDisplayFilter;
    @observable
    public displayEventFilter?: Mri.DisplayEvents.DisplayEventFilter;
    @observable
    public sort: string[] = [];
    @observable
    public where: IWhereClause[] | undefined;
    @observable
    public viewType: DisplayViewTypes = DisplayViewTypes.TableLarge;
}

export const defaultDisplayFilter: Optional<Mri.DisplayFilters.DisplayFilter> = {
    active: true,
};
